import { BookOpen } from 'lucide-react';
import GameLayout from './GameLayout';

interface StatusScreenProps {
  title: string;
  message: string;
  actionLabel?: string;
  onAction?: () => void;
}

export default function StatusScreen({ title, message, actionLabel, onAction }: StatusScreenProps) {
  return <GameLayout><main className="ev-status ev-shell"><span className="ev-brand">Evoke</span><section className="ev-paper" role={onAction ? 'alert' : 'status'}><BookOpen size={28} aria-hidden="true" /><h1 className="ev-display">{title}</h1><p>{message}</p>{onAction && <button type="button" className="ev-button" onClick={onAction}>{actionLabel}</button>}</section></main></GameLayout>;
}
